<template>
  <div>
    <b-navbar class="p-0 dashboard-navbar-background" fixed="top" variant="light">
      <b-navbar-brand class="m-0">
        <img
          class="logo py-3 pl-5"
          src="../assets/images/lntLogo.png"
          data-aos="fade-in" style="padding: 10px;width:95px !important"
          @click="goToHomePage()" 
        />
      </b-navbar-brand>
<span style="font-size: 18px;margin-top: 10px;font-weight: bold;color: #fff !important;"
      :style="[selectedCompanyName.toLowerCase().indexOf('geo') > -1 ? {color:'#fdcb00!important'} : {}]">{{selectedCompanyName}}</span>
      <b-nav tabs align="right" class="m-auto float-right">
        <!-- <b-nav-item class="text-right">Profile</b-nav-item> -->
      </b-nav>
      <!-- <span
        class="navebar-sub-text mt-2 mr-5"
        v-if="($router.currentRoute.name == 'DashboardPage')"
        @click="navigateParnterDashboard()"
      >Profile</span>-->
      <b-navbar-nav v-if="($router.currentRoute.name != 'Summary')" class="m-0" style="margin-right:20px !important;">
        <!-- <b-navbar-brand class="float-right cursor-pointer logout" @click="logOut()">Logout</b-navbar-brand> -->
     <span class="navebar-empanelment-sub-text bell" @click="showReminderList()" 
          style="margin-top: 12px !important;margin-right: 25px !important;cursor:pointer;">
            <img src="../assets/bell.png" style="width: 24px;"/><span v-if="notificationCount && notificationCount>0"
            style="background: red;color: #fff;border-radius: 50px;padding: 3px;font-size: 12px;position: relative;
    top: -14px;right: 10px;">&nbsp;{{notificationCount}}&nbsp;</span>

    <span v-if="showReminders" class ="reminderwrap" style="display: block;max-width: 300px;
    max-height: 400px;background: #fff;padding: 5px;overflow-y: scroll;
    overflow-x: hidden;position: absolute;right: 150px;border: 1px solid #ccc;
    box-shadow: 2px 2px 5px #ccc;border-radius: 5px;"> <div style="text-align: left;
    border-bottom: 1px solid #333333; font-style: italic; font-size: 11px;"> 
    Please click each notification to read </div>
     <span v-for="(notificationDetails,index) in notificationDetailsList" :key="notificationDetails"
     style="border-bottom: 1px solid #b0b0b0;display: block;max-height: 70px;
     padding: 5px !important;margin-bottom: 4px;background: #f6f9f9;cursor:pointer;
     border-radius:5px;overflow: hidden;" @click="notificationClicked(index)">
        <span style="display: block;">
        <span :style="notificationDetails.notificationStatus === 'D' ? 'color:#00000!important;background:#fdfdb7 !important;font-weight:bolder;':'color:#00000!important'"
              @click="notificationClicked(index)"
              class="cursor-pointer col-12" style="display: block;"
              v-html="notificationDetails.description"
            ></span>
            </span>
     </span>
      <span v-if="notificationDetailsList.length == 0" 
      style="padding: 20px;display: block;">No new notifications to show!</span> 

    </span>
          </span>

        <button class="row cursor-pointer popoverButton" id="popover" style="min-width: 100px;">
          <div class="mr-2 mt-1">
            <img class="profile-img" src="@/assets/images/dummydp.png" />
          </div>
          <div class="mr-1">
            <span class="float-right profile-name" v-if="currentBusiness">{{currentBusiness}}</span>
            <span class="float-right profile-name" v-if="!currentBusiness"></span>
          </div>
          <div class="mr-3" style="margin-top:10px">
            <img src="@/assets/images/caret-down.svg" />
            <!-- <b-button id="popover">uish</b-button> -->
          </div>
        </button>
        <b-popover
          target="popover"
          :show.sync="pop1"
          placement="bottomleft"
          ref="popover"
          triggers="focus"
        >
          <p class="m-0 ml-3 mt-2 p-0 selected-business-loginname"
          style="max-width:260px; overflow: hidden; text-overflow: ellipsis;
          white-space: nowrap;" :title="partnerDetails.longDesc">{{partnerDetails.longDesc}}</p>
          <p class="m-0 ml-3 p-0 selected-business-email">{{partnerDetails.designation}}</p> 
          <div style="padding-left:10px;background:#ececec;">
            <span style="width:120px;display:inline-block;font-weight:bold;">Switch Company:</span>
            <select style="width:150px;display:inline-block;appearance: menulist !important;
            -webkit-appearance: menulist !important;" class="form-control" v-model="currentCompany" 
            @change="switchCompany()">
              <option v-for="i in companyList" :key="i"
              :value="i.companyCode">{{i.company}}</option>
            </select>
          </div>
          <hr class="p-0 mt-3 mb-1 m-0" />
          <div class="m-0 p-0 ml-2 bussiness-card">
            <p class="primary-business m-0 p-0">PRIMARY BUSINESS</p>
          </div>
          <div
            class="row m-0 p-0 mt-n1 p-2 business-card cursor-pointer"
            @click="businessSelected(primaryBusiness)"
          >
            <div class="col-8 m-0 p-0 pl-1">
              <p
                class="m-0 p-0 selected-business-heading"
                v-if=" primaryBusiness && primaryBusiness.categoryName"
              >{{primaryBusiness.categoryName}}</p>
            </div>
            <div class="col-2 pl-5 m-auto">
              <img src="@/assets/images/arrow-right.svg" />
            </div>
          </div>
          <div v-if="secondaryBusiness.length > 0" class="m-0 p-0 ml-2 bussiness-card">
            <p class="m-0 p-0 primary-business">SECONDARY BUSINESS</p>
          </div>
          <div
            class="row m-0 p-0 mt-n1 p-2 business-card cursor-pointer"
            v-for="(business,index) in secondaryBusiness"
            :key="index"
            @click="businessSelected(business)"
          >
            <div class="col-8 m-0 p-0 pl-1">
              <p class="m-0 p-0 selected-business-heading" v-if="business">{{business.categoryName}}</p>
            </div>
            <div class="col-2 pl-5 m-auto">
              <img src="@/assets/images/arrow-right.svg" />
            </div>
          </div>
          <hr class="mb-0 m-0" />
          <div class="row m-0 px-1 py-1 cursor-pointer">
            <div class="col m-0 p-0">
              <p class="m-0 p-0 profile-changePassword" @click="changePassword()">Change Password</p>
            </div>
            <div class="col m-0 p-0">
              <p class="m-0 p-0 profile-logout" @click="logOut()">Logout</p>
            </div>
          </div>
          <!-- Each Business Row Ends -->
        </b-popover>
      </b-navbar-nav>
    </b-navbar>
    <!-- Scrolling Message div -->
    <!-- <div class="scrooling-text-div" v-show="alertPresent">
      <b-alert class="p-0 m-0 p-2 alert" show dismissible @dismissed="closeAlert()">
        <marquee class="marquee">
          <p class="scrolling-text">
            <span
              class="scroll-message"
              v-for="scrollMessage in scrollMessages"
              :key="scrollMessage.messageId"
            >{{scrollMessage.message}}</span>
          </p>
        </marquee>
      </b-alert>
    </div>-->
    <div class="notification-card">
      <!--  <b-card v-if="scrollMessages.length > 0" class="card-alert">
        <div class="row card-row">
          <div class="col-sm-1">
            <img :src="require('@/assets/info.png')" alt="info-image" class="img-info" />
          </div>
          <div class="col-sm-9 text-left">
            <span
              class="scroll-message"
              v-if="!readMore"
            >{{scrollMessages[messageIndex].message.slice(0, 100)}}&nbsp;</span>
            <a
              v-if="!readMore && scrollMessages[messageIndex].message.slice(0, 100).length < scrollMessages[messageIndex].message.length"
              @click="readMore=true"
            >
              <span class="read-more-less">Read more...</span>
            </a>
            <span
              class="scroll-message"
              v-if="readMore"
            >{{scrollMessages[messageIndex].message}}&nbsp;</span>
            <a class="read-more-less" v-if="readMore" @click="readMore=false">
              <span class="read-more-less">Read less</span>
            </a>
          </div>
          <div class="col-sm-2 text-right">
            <img
              :src="require('@/assets/baseline-arrow_back.png')"
              alt="arrow-img"
              class="cursor-pointer prev-arrow"
              @click="previousMessage()"
            />&nbsp;
            <img
              :src="require('@/assets/baseline-arrow_back.png')"
              alt="arrow-img"
              class="cursor-pointer next-arrow"
              @click="nextMessage()"
            />&nbsp;
            <b-icon-x-circle-fill class="cursor-pointer" @click="closeMessageCard()"></b-icon-x-circle-fill>
          </div>
        </div>
      </b-card>-->
    </div>
    
    <widgetModal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :isBoldText="boldText"  
      :sscNotification="sscNotification"
      :needResendEmail="needResendEmail"
      :modalSize="'xl'"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModel"
      :showSuccess="successModel"
      @eventClose="handleModel()"
    />
    <w-loadingSpinner :loadSpinner="loading" />
  </div>
</template>

<script>
import { PartnerService } from "../services/partnerService";
const partnerService = new PartnerService();
import { DashboardService } from "../services/DashboardService";
import { types } from "util";
const service = new DashboardService();
import { AESService } from "../services/AES.js";
let aesService = new AESService()
import widgetModal from "../widgets/newModalWidget";
import loadingSpinner from "../widgets/LoadingSpinner";
export default {
  components: {widgetModal,
    "w-loadingSpinner": loadingSpinner
  },
  name: "Navbar",
  data() { 
    return {
      selectedCompanyName: "loading...",
      notificationCount: 0,
      loading:false,
      triggerModal:false,
      lastResponse:'',
      notificationDetailsList:[],
      showReminders: false,
      currentCompany:"1",
      navigationList:[],
      defaultCompanyCode: '',
      defaultCategoryCode: '',
      companyList:[{"company":"LTC","companyCode":1,"isDefault":true},{"company":"GEO","companyCode":8,"isDefault":false}],
      activeClass: "Dashboard",
      currentBusiness: "",
      secondaryBusiness: [],
      partnerDetails: "",
      companyCode: "1",
      currentSelectedBusiness: "",
      showParnterDashboarNavigation: false,
      pop1: false,
      businessList: [
        { name: "Diatoz Solutions Pvt. Ltd.", location: "Coimbatore" },
        { name: "Diatoz Solutions Pvt. Ltd.", location: "Chennai" },
        { name: "Diatoz Pvt. Ltd.", location: "Bangalore" },
        { name: "Diatoz Ltd.", location: "Mumbai" },
        { name: "Diatoz Pvt.", location: "Chennai" }
      ],
      scrollMessages: [],
      alertPresent: true,
      messageIndex: 0,
      readMore: false
    };
  },
  created() {
    // this.getScrollMessages();
    var self = this 
    self.getNotificationDetails()
    EventBus.$on('updateNotificationCount',function(){     
    self.getNotificationDetails()
    });
    $(document).click(function(event) {
       var el = $(event.target)
       console.log(el)
       if (el.parents('.reminderwrap').length || el.parents('.bell').length || el.hasClass('bell')) {
        } else {
          self.showReminders = false
        }
    });
    service.getPartnerCompanies().then(resp => {
          if (resp.failureMessage == "") {
            this.companyList = resp.response.companyMappingResponseList
            this.companyCode = resp.response.companyMappingResponseList.filter(x=>x.isDefault==true)[0].companyCode
            this.selectedCompanyName= resp.response.companyMappingResponseList.filter(x=>x.isDefault==true)[0].longDesc
            this.defaultCompanyCode = resp.response.companyMappingResponseList.filter(x=>x.isDefault==true)[0].companyCode
            this.defaultCategoryCode = resp.response.companyMappingResponseList.filter(x=>x.isDefault==true)[0].categoryCode
            //window.alert(this.selectedCompanyName+" "+this.companyCode)
            this.navigationList = resp.response.companyNavigationResponseList
    this.getPartnerInfo();
    this.currentPartnerTypes();
    if (
      this.$route.params &&
      this.$route.params.onboardStatus == "OnProgress"
    ) {
      var companyCode = this.$route.params.currentCompanyCode;
      var currentBusinessCode = this.$route.params.currentCategoryCode;
      this.currentSelectedBusiness = this.$route.params.currentCategoryName;
      console.log(this.currentBusiness);
      console.log(this.$route.params.currentCategoryName);
      service
        .getProfileDetails(currentBusinessCode, this.companyCode)
        .then(resp => {
          if (resp.response == "User Category Audit Recorded") {
            sessionStorage.getItem("currentCategoryCode", currentBusinessCode)
            sessionStorage.getItem("currentCompanyCode", this.companyCode)
            sessionStorage.getItem("currentCompanyName", this.selectedCompanyName)
            if (this.$router.currentRoute.name != "DashboardPage") {
              this.$router.push("/dashboard");
            } else {
              this.$router.go(this.$router.currentRoute);
            } 
          }
        });
      // this.currentBusinessCode, this.companyCode;
    } else {
    }
    // this.currentPartnerName = this.$route.params.currentCategoryName;
     } else{
           window.alert(resp.failureMessage)
         } })
        .catch(error => {
          this.loading = false;
           window.alert('Error getting company list. Please contact support.')
        });
  },
  watch: {
    currentSelectedBusiness: function(newVal, oldVal) {
      if (newVal) {
        this.currentSelectedBusiness = newVal;
      }
    }
    // showParnterDashboarNavigation: function(newVal, oldVal) {
    //   console.log(newVal);
    //   if (newVal) {
    //     this.currentPartnerTypes();
    //   }
    // }
  },
  methods: {
    showReminderList(){
      this.showReminders = !this.showReminders
    },
    
    handleModel() {
      this.triggerModal = false; 
      this.lastResponse = '';
      this.showReminders = false;
    },
    notificationClicked(index) {
      // this.clickedStatusStyle = "Clicked-"+index;
      this.notificationDetailsList[index].notificationStatus = "R";
      var request = {
        notificationId: this.notificationDetailsList[index].notificationId
      };
      this.lastResponse = this.notificationDetailsList[index].description
      this.triggerModal = true;
      partnerService
        .setNotificationStatus(request)
        .then(res => {
          this.notificationDetailsList[index] = res.response;          
          EventBus.$emit('updateNotificationCount')
        })
        .catch(e => {
          this.loading = false;
        });
    },
    getNotificationDetails() {
      partnerService
        .getNotificationDetails()
        .then(res => {
          this.notificationDetailsList = res.response;
          this.loading = false;
          this.notificationCount = res.response.filter(x=>x.notificationStatus=='D').length          
        })
        .catch(e => {
          this.loading = false;
        });
    },
    calculatedNavigation(currentCategoryCode,currentBusinessCode){
      currentCategoryCode = currentCategoryCode ? currentCategoryCode : this.defaultCompanyCode
      currentBusinessCode = currentBusinessCode ? currentBusinessCode : this.defaultCategoryCode

      var currentNavigationObject = this.navigationList.filter(x=>
      x.companyCode== currentCategoryCode && x.categoryCode== currentBusinessCode)[0]

      console.log(currentNavigationObject)

    },
    switchCompany(){
      
    service.getCompanyNavigation(this.currentCompany).then(resp => {
      console.log(resp)
      this.companyCode = this.currentCompany      
      this.selectedCompanyName= this.companyList.filter(x=>x.companyCode==this.companyCode)[0].longDesc      
      this.businessSelected()
    })
    .catch(err => {
      console.log(err);
      window.alert('Something went wrong!')
      });
    },
    previousMessage() {
      this.readMore = false;
      if (this.messageIndex != 0) {
        this.messageIndex -= 1;
      } else {
        this.messageIndex = this.scrollMessages.length - 1;
      }
    },
    nextMessage() {
      this.readMore = false;
      if (this.messageIndex != this.scrollMessages.length - 1) {
        this.messageIndex += 1;
      } else {
        this.messageIndex = 0;
      }
    },
    closeMessageCard() {
      this.scrollMessages = [];
    },
    navigateParnterDashboard() {
      this.$router.push("/partnerDashboard");
    },
    getPartnerInfo() {
      service.getPartnerDetails(this.companyCode).then(resp => {
        let res = resp.response;
        // if (resp.response.onboardStatus == "A") {
        //   this.$router.push("/partnerdashboard");
        //   return;
        // }
        this.partnerDetails = res;
        this.primaryBusiness = this.partnerDetails.primaryBusiness;
        // this.businessSelected(this.partnerDetails.primaryBusiness);
        // this.currentBusiness = this.partnerDetails.primaryBusiness.categoryName;
        // this.currentBusinessCode =
        this.secondaryBusiness = this.partnerDetails.secondaryBusiness;
        this.currentBusinessCode = this.partnerDetails.currentCategoryCode;
        this.companyCode = this.partnerDetails.currentCompanyCode;
        this.currentCompany = this.companyCode
        this.selectedCompanyName= this.companyList.filter(x=>x.companyCode==this.partnerDetails.currentCompanyCode)[0].longDesc;
        if (this.currentBusinessCode == this.primaryBusiness.categoryCode) {
          this.currentBusiness = this.primaryBusiness.categoryName;
          console.log(this.currentBusiness, "BUSSINESS");
        } else {
          if (this.secondaryBusiness.length > 0) {
            for (let i = 0; i < this.secondaryBusiness.length; i++) {
              if (
                this.currentBusinessCode ==
                this.secondaryBusiness[i].categoryCode
              ) {
                this.currentBusiness = this.secondaryBusiness[i].categoryName;
                console.log(this.currentBusiness, "BUSSINESS");
                this.$forceUpdate();
              }
            }
          }
        }
      });
    },
    currentPartnerTypes() {
      console.log(this.companyCode);
      this.showParnterDashboarNavigation = false;
      if (this.$router.currentRoute.name == "DashboardPage") {
        service.getPartnertype(this.companyCode).then(resp => {
          if (resp.response) {
            resp.response.forEach((item, index) => {
              if (item.status == "A") {
                this.showParnterDashboarNavigation = true;
              }
            });
          }
        });
      }
    },
    getProfileDetails() {
      service
        .getProfileDetails(this.currentBusinessCode, this.companyCode)
        .then(resp => {
          if (resp.response == "User Category Audit Recorded") {
            sessionStorage.setItem("currentCategoryCode", this.currentBusinessCode)
            sessionStorage.setItem("currentCompanyCode", this.companyCode)
            sessionStorage.setItem("currentCompanyName", this.selectedCompanyName)
            if (this.$router.currentRoute.name != "DashboardPage") {
              this.$router.push("/dashboard");
            } else {
              this.$router.go(this.$router.currentRoute);
            }
          }
        });
    },
    // openProfilePopup() {
    //   if (this.pop1 == true) {
    //     this.pop1 = false;
    //   } else {
    //     this.pop1 = true;
    //   }
    //   // this.focusRef(this.$refs.popover)
    // },
    goToRegisterPage() {
      this.$router.push("/registration");
    },
    goToLoginPage() {
      this.$router.push("/login");
    },
    goToHomePage() {
      this.$router.push("/home");
    },
    logOut() {
      var auditNumber = sessionStorage.getItem("AuditNumber");
      let data = {};
      var logouttime = new Date();
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(auditNumber);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      service
        .userLogout(data)
        .then(res => {
          sessionStorage.clear();
          this.$router.push("/login");
        })
        .catch(err => {});
    },
    changePassword() {
      // sessionStorage.removeItem("token");
      this.$router.push({
        name: "ChangePasswordPage",
        params: {
          currentDashboard: "onboardDashboard"
        }
      });
      sessionStorage.setItem("currentroute", "dashboard");
    },

    businessSelected(business) {
      if(business) {
        this.currentBusiness = business.categoryName;
        this.currentBusinessCode = business.categoryCode;
      }
      //this.companyCode = 1;
      this.getProfileDetails();
    },
    getScrollMessages() {
      var scrollMessageRequest = {
        listMessageTypeId: [],
        loginAuditNumber: null
      };
      scrollMessageRequest.listMessageTypeId.push(2);
      scrollMessageRequest.listMessageTypeId.push(4);
      scrollMessageRequest.loginAuditNumber = sessionStorage.getItem(
        "AuditNumber"
      );
      service
        .getScrollMessages(scrollMessageRequest)
        .then(res => {
          if (res.failureMessage == "") {
            this.scrollMessages = res.response;
          } else {
            this.scrollMessages = [];
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.popover {
  left: 24px !important;
  width: 310px !important;
}
.popover-body {
  margin: 0% !important;
  padding: 0% !important;
}
</style>
<style scoped>
select{
appearance: menulist !important; -webkit-appearance: menulist !important;
}
.logo {
  cursor: pointer;
  width: 252px;
}
.empanel-main-header {
  height: 60px;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
}
.profile-img {
  width: 35px;
  height: 35px;
  background: white;
  border-radius: 3px;
}
.popoverButton:focus {
  outline: none;
}
.image-holder {
  background: black;
  border: 1px solid #081933;
  border-radius: 2px;
  height: 100px !important;
}
.selected-business-image {
  width: 100px;
  margin-top: 40px;
  padding-right: 10px;
}
.selected-business-heading {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: #333333;
  padding-left: 6px;
  margin-left: 5% !important;
}
.selected-business-loginname {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  color: #2b2b2b;
}
.selected-business-email {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  color: #7b7b7b;
}
.selected-business-sub-heading {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  text-align: left;
  color: #2b2b2b;
}
.selected-business-location {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2b2b2b;
}
.account-settings {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #002d72;
  cursor: pointer;
}
.account-logout {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  float: right;
  color: #002d72;
  cursor: pointer;
}
.other-business-heading-container {
  background-color: #f4f4f4;
}
.other-business-heading {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #484848;
}
.other-business-image-container {
  height: 68px;
  background-color: black;
}
.other-business-image {
  border-radius: 3px;
  width: 80px;
  margin-top: 28px;
  padding-right: 15px;
}
.other-business-name {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2b2b2b;
}
.other-business-loction {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2b2b2b;
}
.primary-business {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 800;
  text-align: left;
  color: #1579ab;
}
.business-card:hover {
  background-color: #cbd5dd;
}
.profile-name {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.81;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}
.dashboard-navbar-background {
  height: 8vh;
  max-height: 7 vh !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396) !important;
}
.search_img {
  height: 20px;
  width: 15px;
}
.search_bg {
  background-color: #e7edf7;
}
.navbar_login {
  width: 9%;
  background: none;
  border-bottom: 0;
  border-top: 0;
  border-color: rgba(0, 0, 0, 0.16);
  border-radius: 0;
  color: #002d72;
  padding-left: 60.5px !important;
  padding-right: 60.5px !important;
}
.margins {
  margin-left: 10% !important;
}
.menu_style {
  height: 104px;
  font-size: 20px;
  border: none;
  border-radius: 0;
  background-color: #002d72;
  color: white !important;
  outline: none;
  padding-left: 20px;
  padding-right: 20px;
}
.menu-nav-bg {
  background: #002d72;
}
.menu-item {
  font-size: 20px;
  line-height: 1.35;
  text-align: left;
  color: #ffffff !important;
}
.navbar-light .navbar-nav .nav-link {
  color: #ffffff !important;
  padding-top: 20px;
  padding-bottom: 20px;
}
.navbar-menu-row {
  margin: 0 auto auto auto !important;
}
.logout {
  color: #ffffff !important ;
  padding-right: 20%;
}
.nav-tabs {
  border-bottom: 0;
}
.active > .nav-link {
  color: #ffffff !important;
  opacity: 1 !important;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  opacity: 0.7;
}
.nav-tabs .nav-link {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  opacity: 0.7;
  border: none !important;
  text-decoration: none;
}
.nav-tabs .nav-item {
  padding-left: 10px;
  padding-right: 10px;
}
.summary-account-logout {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.55;
  color: #ffffff !important;
  border: none !important;
}
.summary-account-logout:hover {
  border-bottom: 1px solid #ffffff !important;
}
.bs-popover-bottom,
.bs-popover-auto {
  left: -15px !important;
}
.profile-logout {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: normal;
  text-align: right !important;
  padding-right: 7% !important;
  color: #002d72;
}
.profile-changePassword {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: normal;
  color: #002d72;
}
.navebar-sub-text {
  /* margin-left: auto !important; */
  font-family: "Source Sans Pro", sans-serif;
  float: right !important;
  color: whitesmoke !important;
  font-weight: bold !important;
  font-size: 18px !important;
  cursor: pointer;
}
.navebar-sub-text:hover {
  text-decoration: underline;
}
.notification-card {
  margin-top: 7vh !important;
}
.card-alert {
  margin-bottom: -60px;
  box-shadow: 0px 1px 6px #00000029;
  opacity: 1;
  background-color: #d1ecf1;
}
.card-row {
  margin: 0 0 0 0;
  position: inherit;
}
.scroll-message {
  padding: 0 0 0 0;
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 200;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}
.read-more-less {
  color: #0c5e9d;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 200;
}
.prev-arrow {
  transform: matrix(-1, 0, 0, -1, 0, 0);
  background: transparent 0% 0% no-repeat padding-box;
  opacity: 1;
}
.next-arrow {
  background: transparent 0% 0% no-repeat padding-box;
  opacity: 1;
}
.img-info {
  background: transparent 0% 0% no-repeat padding-box;
  opacity: 1;
}
/* .scrolling-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-top: -3px;
  padding: 0;
}
.scroll-message {
  padding-left: 5em;
} */
</style>
